"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSidebarBtnDragOverLay = exports.DocumentSidebarBtn = void 0;
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const doshx_controls_web_1 = require("doshx_controls_web");
const core_1 = require("@dnd-kit/core");
const cn_1 = require("../../../../../helpers/cn");
const DocumentSidebarBtn = ({ documentElement, color, disabled = false }) => {
    color = color !== null && color !== void 0 ? color : "secondary";
    const { label, icon } = documentElement.sidebarBtnElement;
    const draggable = (0, core_1.useDraggable)({
        id: `document-btn-${documentElement.type}`,
        data: {
            type: documentElement.type,
            dragType: "drop",
            isDocumentBtnElement: true,
        },
        disabled: disabled, // Disable drag when elements are being created
    });
    return (react_1.default.createElement("div", Object.assign({ ref: draggable.setNodeRef, className: (0, cn_1.cn)(`bg-white border border-${color} p-1.5 md:py-2 md:px-4 w-auto md:w-72 rounded-sm`, disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer", !disabled && draggable.isDragging && "ring-2 ring-secondary") }, (disabled ? {} : draggable.listeners), (disabled ? {} : draggable.attributes), { style: { touchAction: disabled ? 'auto' : 'none' }, title: label }),
        react_1.default.createElement("div", { className: `flex justify-center items-center gap-1 md:gap-2 bg-white border border-${color} p-1 md:p-1.5 rounded-sm` },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: `font-bold text-base md:text-base ${disabled ? "text-gray-400" : "text-secondary"}` }),
            react_1.default.createElement("span", { className: "hidden md:block" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: label, size: "xsmall", textColor: disabled ? "text-gray-400" : "text-secondary" })))));
};
exports.DocumentSidebarBtn = DocumentSidebarBtn;
const DocumentSidebarBtnDragOverLay = ({ documentElement }) => {
    const { label, icon } = documentElement.sidebarBtnElement;
    const draggable = (0, core_1.useDraggable)({
        id: `document-btn-${documentElement.type}`,
        data: {
            type: documentElement.type,
            isDocumentBtnElement: true,
        },
    });
    // Match the overlay size to the field's placed dimensions so the visual
    // bounds during drag align with where the field will land. Without this the
    // overlay (originally w-52 / 208px) is wider than the placed field
    // (150px default for inputs, 144px for Signature/Initials), so dropping
    // produces a perceived "shift" even though the centre-on-cursor math is
    // correct. Defaults mirror droppable.tsx and document_element_wrapper.tsx.
    const sample = documentElement.construct("preview", 0);
    const overlayWidth = sample.width || 150;
    const overlayHeight = sample.height || 50;
    return (react_1.default.createElement("div", { className: "bg-white border border-secondary rounded-sm cursor-pointer flex items-center justify-center", style: { width: `${overlayWidth}px`, height: `${overlayHeight}px` } },
        react_1.default.createElement("div", { className: "flex justify-center items-center gap-2 px-2" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: "font-bold text-secondary" }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: label, size: "xsmall", textColor: "text-secondary" }))));
};
exports.DocumentSidebarBtnDragOverLay = DocumentSidebarBtnDragOverLay;
